import { RibbonElementAutocomplete } from "./RibbonElementAutocomplete.jsx";
import RibbonElementCommon from "./RibbonElementCommon.jsx";
import { RibbonElementControlledRadio } from "./RibbonElementControlledRadio.jsx";
import RibbonElementControlledSelectCheckbox from "./RibbonElementControlledSelectCheckbox";
import RibbonElementCustom from "./RibbonElementCustom.jsx";
import RibbonElementRadio from "./RibbonElementRadio.jsx";
import RibbonElementSelect from "./RibbonElementSelect.jsx";
import RibbonElementSelectCustomOptions from "./RibbonElementSelectCustomOptions.jsx";
import RibbonElementSeparateSelect from "./RibbonElementSeparateSelect.jsx";

const RibbonElementWrapper = ({ elementSettings }) => {
	const { type } = elementSettings;

	if (type === "common") {
		return <RibbonElementCommon elementSettings={elementSettings} />;
	} else if (type === "select") {
		return <RibbonElementSelect elementSettings={elementSettings} />;
	} else if (type === "custom") {
		return <RibbonElementCustom elementSettings={elementSettings} />;
	} else if (type === "radio") {
		return <RibbonElementRadio elementSettings={elementSettings} />;
	} else if (type === "separate-select") {
		return <RibbonElementSeparateSelect elementSettings={elementSettings} />;
	} else if (type === "select-custom-options") {
		return <RibbonElementSelectCustomOptions elementSettings={elementSettings} />;
	} else if (type === "autocomplete") {
		return <RibbonElementAutocomplete elementSettings={elementSettings} />;
	} else if (type === "controlled-radio") {
		return <RibbonElementControlledRadio elementSettings={elementSettings} />;
	} else if (type === "controlled-select-checkbox") {
		return <RibbonElementControlledSelectCheckbox elementSettings={elementSettings} />;
	}
	return null;
};

export default RibbonElementWrapper;
